/**
 * The pure part of the seller name form (components/Sellers.tsx).
 *
 * The form opens on the name and note stored now, but between opening it and
 * saving, the note may have been edited elsewhere (another tab, the Known sellers
 * page). So the note rides in the save only when the owner actually changed the
 * field here; left alone, the key is omitted and the API keeps whatever note is
 * stored. An edited-to-empty note is sent as null, which clears it.
 */

export interface SellerAliasBody {
  name: string;
  note?: string | null;
}

/** The `PUT /api/sellers/:sellerId` body for what the form holds. */
export function sellerAliasBody(name: string, note: string, noteTouched: boolean): SellerAliasBody {
  if (!noteTouched) return { name };
  return { name, note: note.trim() ? note : null };
}
